(function(){
  function clampInput(input, showAlert){
    if(!input || input.disabled) return true;
    var maxAttr=input.getAttribute('max');
    if(!maxAttr) return true;
    var max=parseInt(maxAttr,10);
    var val=parseInt(input.value||'0',10);
    if(isNaN(max)) return true;
    if(isNaN(val)) val=0;
    if(val>max){
      input.value=String(max);
      input.dispatchEvent(new Event('change',{bubbles:true}));
      if(showAlert){
        var message=max<=0 ? 'Este producto está agotado.' : 'Solo hay '+max+' pieza'+(max===1?'':'s')+' disponible'+(max===1?'':'s')+' para este producto.';
        var holder=input.closest('.vh-product-ml__form') || input.closest('.cart-item') || input.closest('quantity-input') || document;
        var error=holder.querySelector('[data-aj-quantity-error]');
        if(error){ error.textContent=message; error.hidden=false; }
      }
      return false;
    }
    return true;
  }
  document.addEventListener('input',function(e){
    var input=e.target.closest('input[type="number"][max]');
    if(input) clampInput(input,true);
  },true);
  document.addEventListener('change',function(e){
    var input=e.target.closest('input[type="number"][max]');
    if(input) clampInput(input,true);
  },true);
  document.addEventListener('click',function(e){
    var btn=e.target.closest('quantity-input .quantity__button[name="plus"]');
    if(!btn) return;
    var input=btn.closest('quantity-input').querySelector('input[type="number"][max]');
    if(!input) return;
    setTimeout(function(){ clampInput(input,true); },0);
  },true);
  document.addEventListener('submit',function(e){
    var bad=false;
    e.target.querySelectorAll('input[type="number"][max]').forEach(function(input){ if(!clampInput(input,true)) bad=true; });
    if(bad){ e.preventDefault(); e.stopPropagation(); }
  },true);
})();
